import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { RefreshCw } from 'lucide-react';
import { Button } from '../ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CarfaxSyncButton = ({ headers, onDone }) => {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/admin/carfax/sync`, {}, { headers, timeout: 600000 });
      toast.success(`CARFAX : ${data.updated} mis à jour, ${data.no_report} sans rapport${data.errors ? `, ${data.errors} erreurs` : ''}`);
      onDone?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Synchronisation CARFAX impossible');
    } finally {
      setBusy(false);
    }
  };
  return (
    <Button onClick={run} disabled={busy} variant="outline" className="border-slate-300" data-testid="carfax-sync-button">
      <RefreshCw className={`h-4 w-4 mr-2 ${busy ? 'animate-spin' : ''}`} />
      {busy ? 'CARFAX…' : 'Synchroniser CARFAX'}
    </Button>
  );
};
